export default __webpack_public_path__ + "static/media/suprised-pepe.8ea196af.jpeg";